export default __webpack_public_path__ + "static/careers-hero-2-3889b1d211d57e68db785a5b8f632e83.png";